import { $api } from '@service/RequestService';
import { useMutation } from 'react-query';

export const useNewsPostScheduleSave = () =>
  useMutation(async (data: { scheduleEmployeeId: number; ignore?: boolean; clickUrl?: boolean }) => {
    const res = await $api.post('/v1/news-post-schedule', data);

    return res?.data;
  });
